export const capitalize=(str)=>{
    let ans=str.split('-').map((elem)=>elem.charAt(0).toUpperCase()+elem.slice(1)).join(' ');
    return ans;
}